import React, { memo } from 'react'
import CarrierStatus from 'components/marketplace/CarrierStatus'
import { ConnectedPhoneNumber } from 'apps/marketplace/components/ConnectedPhoneNumber'
import LaneAlertRecipients from './LaneAlertRecipients'
import { IMatchRow } from './MatchRow'

export const CarrierSummary = memo<IMatchRow>(
  ({
    match: {
      carrierId,
      carrierName,
      carrierState,
      laneAlert,
      metadata: { dispatcherName, dispatcherPhone, dispatcherPhoneExt, recipients },
    },
  }) => {
    return (
      <>
        <div>
          <a href={`${__ROOT__}/carriers/${carrierId}`} target='_blank' rel='noopener noreferrer'>
            {carrierName}
          </a>
          &nbsp; <CarrierStatus status={carrierState} displayStatus={false} warnOnly showTooltip />
        </div>
        {!laneAlert ? (
          <div>
            {dispatcherName} &nbsp;
            {dispatcherPhone && (
              <span>
                <ConnectedPhoneNumber
                  phoneNumber={dispatcherPhone}
                  phoneExtension={dispatcherPhoneExt}
                />
              </span>
            )}
          </div>
        ) : (
          recipients && <LaneAlertRecipients carrierId={carrierId} recipients={recipients} />
        )}
      </>
    )
  }
)
